import { isHosted } from "owa-config/lib/isHosted";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import getWin32StyleEnabled from "./getWin32StyleEnabled";

/**
 * Determines if Win32 styling UI changes should be applied.
 *
 * Returns true only when all conditions are met:
 * 1. The experience is not hosted
 * 2. The 'mon-win32-styling' feature flight is enabled (controls server-side rollout)
 * 3. The user has enabled the Win32 style setting (controls user choice)
 *
 * @returns true if Win32 styling is flighted and enabled by the user in a non-hosted experience
 */
export default function isWin32StylingEnabled(): boolean {
    return !isHosted() && isGlobalFeatureEnabled("mon-win32-styling") && getWin32StyleEnabled();
}
